import React from "react";
import { Loader2, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { btnPrimary, btnGhost } from "@/components/Brand";

/** Shown once per session when a trial studio's client taps Submit. */
export const TrialUpsellModal = ({ busy, onClose, onSubmit }) => {
  const { t } = useI18n();

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center px-5" data-testid="trial-upsell-modal">
      <div className="relative max-w-md w-full border border-[#2A2A2A] bg-[#0B0B0B] p-8">
        <button data-testid="upsell-close-btn" onClick={onClose}
          aria-label={t("close")} className="absolute top-4 right-4 text-[#707070] hover:text-[#D4AF37]">
          <X size={16} />
        </button>
        <p className="eyebrow">{t("powered_by")}</p>
        <h2 className="mt-3 text-2xl tracking-tight">{t("trial_upsell_title")}</h2>
        <p className="mt-4 text-sm text-[#A8A8A8] leading-relaxed">{t("trial_upsell_body")}</p>
        <div className="mt-7 flex flex-wrap gap-3">
          <button data-testid="upsell-continue-btn" onClick={onSubmit} disabled={busy} className={btnPrimary}>
            {busy && <Loader2 size={12} className="animate-spin" />} {t("submit_selection")}
          </button>
          <a data-testid="upsell-plans-link" href="/" target="_blank" rel="noreferrer" className={btnGhost}>
            {t("see_plans")}
          </a>
        </div>
      </div>
    </div>
  );
};
